import { ButtonBase, Card, Typography } from '@mui/material';

export default function RequestTypeCard({
  image,
  title,
  description,
  selected,
  select,
}) {
  return (
    <ButtonBase>
      <Card
        sx={{
          p: '16px',
          aspectRatio: 1,
          boxShadow: 'none',
          outlineStyle: 'solid',
          outlineWidth: selected ? '2px' : '1.5px',
          color: selected ? 'primary.main' : 'black',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          display: 'flex',
          flexFlow: 'column',
        }}
        onClick={select}
      >
        <img
          src={image}
          alt={title}
          style={{ paddingBottom: '10px', width: '100%' }}
        />
        <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: '12px', textAlign: 'left' }}>
          {description}
        </Typography>
      </Card>
    </ButtonBase>
  );
}
